const AppSettings = {
  SystemAgencyID: 1,
  SystemSupplierID: 1,
};
export default AppSettings;
